import { useContext } from "react";
import { LoadingContext } from "../contexts/LoadingContext";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

const LoadingOverlay = () => {
  const { isLoading } = useContext(LoadingContext);
  const { t } = useTranslation();

  let location;
  try {
    location = useLocation();
  } catch (error) {
    console.error("useLocation() n'est pas disponible ici !");
    return null;
  }

  if (
    !isLoading ||
    location?.pathname === "/home" ||
    location?.pathname === "/"
  )
    return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm z-50 transition-opacity duration-300">
      <div className="flex flex-col items-center space-y-4">
        <span className="loading loading-ring loading-lg text-white"></span>
        <p className="text-white text-lg font-semibold">{t("loading")}</p>
      </div>
    </div>
  );
};

export default LoadingOverlay;
